import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=d544862a&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d544862a')) {
      api.createRecord('d544862a', component.options)
    } else {
      api.reload('d544862a', component.options)
    }
    module.hot.accept("./NoData.vue?vue&type=template&id=d544862a&", function () {
      api.rerender('d544862a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/NoData.vue"
export default component.exports